import styled, {
  css,
} from 'styled-components/macro';
import React from 'react';
import PropTypes from 'prop-types';
import {
  theme,
} from '../../../utilsClient/cssHelpers';

const styles = css`
  > * {
    margin: 0;

    /* Experimental */
    /* line-height: 1; */
  }

  > * + * {
    margin-top: ${props => theme(`space.${props.space}`)};
  }
`;

const StackDefault = styled.div`
  ${styles};
`;

const StackList = styled.ul`
  ${styles};
`;

const Stack = ({
  space,
  asList,
  children,
  // eslint-disable-next-line react/prop-types
  className,
  'data-testid': datatestid,
}) => {
  const props = {
    space,
    className,
    'data-testid': datatestid,
  };

  return asList ? (
    <StackList {...props}>{children}</StackList>
  ) : (
    <StackDefault {...props}>{children}</StackDefault>
  );
};

Stack.propTypes = {
  children: PropTypes.node.isRequired,
  space: PropTypes.oneOf([
    0,
    1,
    2,
    3,
    4,
    5,
  ]),
  asList: PropTypes.bool,
  'data-testid': PropTypes.string,
};

Stack.defaultProps = {
  space: 3,
  asList: false,
  'data-testid': 'default-stack',
};

export default Stack;
